import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const pause = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const applicationManagementApi = createApi({
  reducerPath: "applicationManagement",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
    fetchFn: async (...args) => {
      await pause(1000);
      return fetch(...args);
    },
  }),
  endpoints(builder) {
    return {
      //izin tipi
      fetchDayoffTypeDocuments: builder.query({
        providesTags: (result, error, arg) => ["dayofftype-documents"],
        query: (id) => {
          return {
            url: `dayofftype/documents?dayoffTypeId=${id}`,
            method: "GET",
          };
        },
      }),
      fetchGetDayoffTypes: builder.query({
        providesTags: (result) => ["dayoff-types"],
        query: (pagination) => {
          return {
            url:
              pagination !== undefined
                ? `dayofftype?page=${pagination.page}&limit=${pagination.limit}`
                : "dayofftype/",
            method: "GET",
          };
        },
      }),
      postDayoffTypes: builder.mutation({
        invalidatesTags: () => ["dayoff-types"],
        query: (model) => {
          return {
            url: "dayofftype/",
            method: "POST",
            body: model,
          };
        },
      }),
      deleteDayoffTypes: builder.mutation({
        invalidatesTags: ["dayoff-types", "dayoff-documents"],
        query: (id) => {
          return {
            url: `dayofftype?id=${id}`,
            method: "DELETE",
          };
        },
      }),

      //döküman tipi
      fetchGetDocumentTypes: builder.query({
        providesTags: () => ["document-types"],
        query: (pagination) => {
          return {
            url:
              pagination !== undefined
                ? `documenttype?page=${pagination.page}&limit=${pagination.limit}`
                : "documenttype/",
            method: "GET",
          };
        },
      }),
      postDocumentType: builder.mutation({
        invalidatesTags: ["document-types"],
        query: (model) => {
          return {
            url: "documenttype/",
            method: "POST",
            body: model,
          };
        },
      }),
      deleteDocumentType: builder.mutation({
        invalidatesTags: ["document-types", "dayoff-documents"],
        query: (id) => {
          return {
            url: `documenttype?id=${id}`,
            method: "DELETE",
          };
        },
      }),

      //izin dökümanları
      fetchGetDayoffTypeDocuments: builder.query({
        providesTags: () => ["dayoff-documents"],
        query: (pagination) => {
          return {
            url:
              pagination !== undefined
                ? `dayofftypedocument?page=${pagination.page}&limit=${pagination.limit}`
                : "dayofftypedocument/",
            method: "GET",
          };
        },
      }),
      postDayoffTypeDocuments: builder.mutation({
        invalidatesTags: ["dayoff-documents"],
        query: (model) => {
          return {
            url: "dayofftypedocument/",
            method: "POST",
            body: model,
          };
        },
      }),
      deleteDayoffTypeDocument: builder.mutation({
        invalidatesTags: ["dayoff-documents"],
        query: (id) => {
          return {
            url: `dayofftypedocument?id=${id}`,
            method: "DELETE",
          };
        },
      }),
    };
  },
});

export const {
  useFetchDayoffTypeDocumentsQuery,
  useFetchGetDayoffTypesQuery,
  useFetchGetDocumentTypesQuery,
  useFetchGetDayoffTypeDocumentsQuery,
  usePostDayoffTypesMutation,
  useDeleteDayoffTypesMutation,
  usePostDocumentTypeMutation,
  useDeleteDocumentTypeMutation,
  usePostDayoffTypeDocumentsMutation,
  useDeleteDayoffTypeDocumentMutation,
} = applicationManagementApi;
export { applicationManagementApi };
